import { put, takeEvery, call, select } from 'redux-saga/effects';
import { SignUpActions } from './actions';
import ApiService from '../../../Services/ApiService';
import { AppActions } from '../app/actions';
import { displayNotification, history, getUseCaseTextFromKey } from '../../../Utils/GenericUtils';
import { SignUpSelectors } from './selectors';

export function* submitSignUp(action) {
  try {
    const payloadParams = action.payload;
    const reducerParams = yield select(SignUpSelectors.signUpFieldsSelector);
    const prepopulatedParams = yield select(SignUpSelectors.signUpPrePopulatedFieldsSelector);
    const { email } = payloadParams;
    const params = {
      first_name: payloadParams.firstName,
      last_name: payloadParams.lastName,
      agree_to_terms: payloadParams.terms,
      agree_to_business_application: payloadParams.confirmUsage,
      email: payloadParams.email,
      phone: payloadParams.phone,
      country: payloadParams.country || null,
      product: prepopulatedParams ? prepopulatedParams.product : reducerParams.product || payloadParams.product,
      use_case_code: prepopulatedParams ? prepopulatedParams.useCaseCode : reducerParams.useCaseCode,
      sub_use_case_code: prepopulatedParams ? prepopulatedParams.subUseCaseCode : reducerParams.subUseCaseCode,
      use_case_category_text: prepopulatedParams
        ? getUseCaseTextFromKey(prepopulatedParams.useCaseText)
        : getUseCaseTextFromKey(reducerParams.useCaseText) || null,
      use_case_sub_category_text:
        prepopulatedParams.otherDescription?.length > 1 ? prepopulatedParams.otherDescription : null,
    };

    const emailUrlPath = yield call(ApiService.generateLink, 'email-confirm/');
    yield call(ApiService.signUpNoVetting, { params });
    yield put(AppActions.setOnBoardingEmailConfirm(email));
    yield put(SignUpActions.submitSignUpSucceeded());
    history.push(`${emailUrlPath}`);
    window.location.reload();
  } catch (e) {
    const data = e?.response?.data;
    if (e.response?.data === 'Failed captcha validation') {
      yield put(SignUpActions.submitSignUpFailed(data));
      displayNotification(
        'error',
        'Error',
        'Your session is expired, please refresh the page and fill your sign-up form again',
      );
    } else {
      yield put(SignUpActions.submitSignUpFailed(data));
      displayNotification(
        'error',
        'Error',
        'There was an error while processing your sign up request. Please try again later.',
      );
    }
  }
}

export function* resendConfirmationEmail(action) {
  try {
    const res = yield call(ApiService.resendConfirmationEmail, action.payload);
    yield put(SignUpActions.resendConfirmationEmailSucceeded(res));
    displayNotification('success', 'Success', 'Email was resent, please check your inbox!');
  } catch (e) {
    yield put(SignUpActions.resendConfirmationEmailFailed());
    if (e.response.data === 'Please wait 10 minutes before resending email again')
      displayNotification('error', 'Error', 'Please wait 10 minutes before resending email');
  }
}

export function* watchSignUp() {
  yield takeEvery(SignUpActions.submitSignUp, submitSignUp);
  yield takeEvery(SignUpActions.resendConfirmationEmail, resendConfirmationEmail);
}
